
import { useContext, useState } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import Modal from "components/ui/modal/modal";
import Button from "components/ui/controls/button/button";
import { createStyledButton } from "components/ui/controls/button/button-styles";
import { FaFileAlt, FaPlusCircle, FaEdit, FaTrashAlt, FaPiggyBank, FaShieldAlt, FaHeartbeat, FaBriefcase, FaClipboardList } from "react-icons/fa";
import ContratsFacultatifSelect from "components/app/AuditComplet/SituationPro/ContratsFacultatifSelect";
import ContratPrevoyancePageModal from "./contrat prevoyance modal";
import ContratSantePageModal from "./contrat sante modal";
import Row from "components/ui/layout/row/row";
import Column from "components/ui/layout/column/column";
import ContratFraisProPageModal from "./contrat frais pro modal";
import ContratRetraitePageModal from "./contrat retraite modal";
import { applyFormat } from "components/ui/ui-helpers";
import Dialogs from "components/ui/dialogs/dialogs";
import "../../../../components/app/Extranet/ListeClients.css";
import "../SituationProfessionnelle.css";
import "../../../../components/app/settings/settings.css";

// Composant moderne pour l'état vide inspiré du fichier situation professionnelle
export const EmptyStateMessage = () => {
  return (
    <div className="empty-state-container" style={{ paddingBottom: '16px' }}>
      <div className="empty-state-content">
        {/* Message d'information avec style InfoMessage */}
        <div className="settings-text-helper" style={{ marginTop: 0, marginBottom: '12px' }}>
          <p>💡 Aucun contrat facultatif n'est actuellement souscrit pour ce client. Cliquez sur le bouton "Ajouter un contrat" ci-dessus pour commencer.</p>
        </div>
        
        <div className="empty-state-illustration">
          <div className="empty-state-icon-bg">
            <FaClipboardList className="empty-state-icon" />
          </div>
          <div className="empty-state-decoration">
            <div className="decoration-dot decoration-dot-1"></div>
            <div className="decoration-dot decoration-dot-2"></div>
            <div className="decoration-dot decoration-dot-3"></div>
          </div>
        </div>
        
        <div className="empty-state-text">
          <h3 className="empty-state-title">
            Aucun contrat souscrit
          </h3>
          <p className="empty-state-subtitle">
            Commencez par ajouter votre premier contrat facultatif.
          </p>
        </div>
      </div>
    </div>
  );
};

function AjoutContratFacultatifPageModal(props) {
  const context = useContext(AppContext);
  const [modalOpen, setmodalOpen] = useState(false);
  const [modalContratPrevOpen, setmodalContratPrevOpen] = useState(false);
  const [modalContratRetraiteOpen, setmodalContratRetraiteOpen] = useState(false);
  const [modalContratSanteOpen, setmodalContratSanteOpen] = useState(false);
  const [modalContratFraisProOpen, setmodalContratFraisProOpen] = useState(false);
  const annee = new Date().getFullYear();
  const CorrespondanceContrat = {
    Madelin: "Madelin",
    Perp: "PERP",
    Per: "PER",
    Article62: "Assurance vie",
    Article83: "Article 83",
    Pero: "PER obligatoire",
    PEE: "PEE",
    PERCO: "PERECO",
  };

  // useEffect(() => {
  //   if(modalOpen===true){
  //   context.handleResetPrevoyanceSettings();
  //   context.handleResetSanteSettings();
  //   context.handleResetContratRetraite();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [modalOpen]);
  return (
    <>
      <Row tpad>
        <Column style={{ flex: "0 0 auto", marginRight: "16px" }}>
          <Button
            {...createStyledButton("primary")}
            onClick={() => setmodalOpen(true)}
          >
            <FaPlusCircle style={{ marginRight: "8px" }} />
            Ajouter un contrat
          </Button>
        </Column>
      </Row>
      <Modal
        width="30%"
        height="50%"
        title="Ajouter un contrat"
        icon={<FaFileAlt />}
        visible={modalOpen}
        onClose={() => {
          setmodalOpen(false);
        }}
      >
        <ContratsFacultatifSelect
        Outil={props.Outil}
        Statut={props.Statut}
          visible={modalOpen}
          ClientConjoint={props.ClientConjoint}
          onClose={(typeContrat) => {
            setmodalOpen(false);
            if (typeContrat === "prevoyance") {
              setmodalContratPrevOpen(true);
            } else if (typeContrat === "retraite") {
              setmodalContratRetraiteOpen(true);
            } else if (typeContrat === "sante") {
              setmodalContratSanteOpen(true);
            } else if (typeContrat === "fraisPro") {
              setmodalContratFraisProOpen(true);
            }
          }}
        />
      </Modal>
      <ContratPrevoyancePageModal
        AccessRemExpress={props.AccessRemExpress}
        visible={modalContratPrevOpen}
        Outil={props.Outil}
        PayeurPrime="Entreprise"
        Statut={props.Statut}
        ClientConjoint={props.ClientConjoint}
        CliConj={[props.CliConj]}
        onClose={() => {
          setmodalContratPrevOpen(false);
        }}
      />
      <ContratRetraitePageModal
        AccessRemExpress={props.AccessRemExpress}
        visible={modalContratRetraiteOpen}
        Outil={props.Outil}
        Statut={props.Statut}
        PayeurPrime="Entreprise"
        ClientConjoint={props.ClientConjoint}
        CliConj={props.CliConj}
        onClose={() => {
          setmodalContratRetraiteOpen(false);
        }}
      />
      <ContratSantePageModal
        AccessRemExpress={props.AccessRemExpress}
        visible={modalContratSanteOpen}
        Outil={props.Outil}
        PayeurPrime="Entreprise"
        Statut={props.Statut}
        ClientConjoint={props.ClientConjoint}
        onClose={() => {
          setmodalContratSanteOpen(false);
        }}
      />
      <ContratFraisProPageModal


AccessRemExpress={props.AccessRemExpress}
        visible={modalContratFraisProOpen}
        Outil={props.Outil}
        ClientConjoint={props.ClientConjoint}
        onClose={() => {
          setmodalContratFraisProOpen(false);
        }}
      />

      <Row style={{ marginTop: '12px' }}>
        <div className="client-card-list" style={{ width: '100%', minHeight: '0', maxWidth: '100%', margin: 0, boxSizing: 'border-box', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: 8 }}>
          {/* Vérifier si aucun contrat n'est souscrit */}
          {context.state[props.Outil + "ListeContrat" + props.ClientConjoint].filter(Infos => Infos.PayeurPrimeRetraite === "Entreprise").length === 0 &&
           context.state[props.Outil + "ContratEnregistre" + props.ClientConjoint].length === 0 &&
           context.state[props.Outil + "ContratFraisPro" + props.ClientConjoint].length === 0 &&
           context.state[props.Outil + "ContratEnregistreSante" + props.ClientConjoint].length === 0 && (
            <EmptyStateMessage />
          )}
          
          {context.state[props.Outil + "ListeContrat" + props.ClientConjoint].map((Infos, Index) =>
            Infos.PayeurPrimeRetraite === "Entreprise" && (
              <div key={"contrat-"+Infos.id} className="client-card" style={{ minHeight: 56, padding: '10px 12px' }}>
                <div className="client-card-main">
                  <div className="client-card-info">
                    <div className="client-card-avatar" style={{ backgroundColor: '#e3f2fd' }}>
                      <FaPiggyBank style={{ color: '#3b82f6', fontSize: '16px' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div className="client-card-row">
                        <h4 className="client-card-title">{props.AccessRemExpress === false ? Infos.Compagnie : `Retraite - ${CorrespondanceContrat[Infos.Fiscalite]}`}</h4>
                      </div>
                      <div className="client-card-row">
                        <span style={{
                          display: 'inline-block',
                          background: '#e3f2fd',
                          color: '#2563eb',
                          fontSize: 12,
                          fontWeight: 500,
                          borderRadius: 12,
                          padding: '2px 10px',
                          margin: '2px 0'
                        }}>Épargne-retraite - {CorrespondanceContrat[Infos.Fiscalite]}</span>
                      </div>
                      <div className="client-card-date">
                        {applyFormat(typeof Infos.Cotisation === "object" ? (annee in Infos.Cotisation ? Infos.Cotisation[annee].Versement : 0) : Infos.Cotisation, "uint", { thousands: " ", decimal: ",", unit: " € / an" })}
                      </div>
                    </div>
                  </div>
                  <div className="client-card-actions" style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                    <Button
                      icon
                      {...createStyledButton("card-action", "cardEdit")}
                      onClick={() => {
                        context.handleModifyDeleteContratRetraite(Infos.id, "Modifier", props.Outil, props.ClientConjoint);
                        setmodalContratRetraiteOpen(true);
                      }}
                    >
                      <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                    </Button>
                    <Button
                      icon
                      {...createStyledButton("card-action", "delete")}
                      onClick={() => {
                        Dialogs.confirm(
                          "Vous êtes sur le point de supprimer le contrat.\nVoulez-vous continuer ?",
                          "Suppression du contrat",
                          () => {
                            context.handleModifyDeleteContratRetraite(Infos.id, "Supprimer", props.Outil, props.ClientConjoint);
                          }
                        );
                      }}
                    >
                      <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
                    </Button>
                  </div>
                </div>
              </div>
            )
          )}
          {context.state[props.Outil + "ContratEnregistre" + props.ClientConjoint].map((Infos, Index) => (
            <div key={"prevoyance-"+Infos.id} className="client-card" style={{ minHeight: 56, padding: '10px 12px' }}>
              <div className="client-card-main">
                <div className="client-card-info">
                  <div className="client-card-avatar" style={{ backgroundColor: '#dcfce7' }}>
                    <FaShieldAlt style={{ color: '#22c55e', fontSize: '16px' }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div className="client-card-row">
                      <h4 className="client-card-title">{props.AccessRemExpress === false ? Infos.LibelleContrat : "Prévoyance - Risques lourds"}</h4>
                    </div>
                    <div className="client-card-row">
                      <span style={{
                        display: 'inline-block',
                        background: '#dcfce7',
                        color: '#22c55e',
                        fontSize: 12,
                        fontWeight: 500,
                        borderRadius: 12,
                        padding: '2px 10px',
                        margin: '2px 0'
                      }}>Prévoyance - Risques lourds</span>
                    </div>
                    <div className="client-card-date">
                      {applyFormat(Number(Infos.PrevoyanceMadelin) + Number(Infos.PrevoyanceNonMadelin) + Number(Infos.Cotisation83), "uint", { thousands: " ", decimal: ",", unit: " € / an" })}
                    </div>
                  </div>
                </div>
                <div className="client-card-actions" style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                  {Infos.PayeurPrimePrevoyance === "Entreprise" && <>
                    <Button
                      icon
                      {...createStyledButton("card-action", "cardEdit")}
                      onClick={() => {
                        context.handleModifyDeleteContratPrevoyance(Infos.id, "Modifier", "Prevoyance", props.Outil, props.ClientConjoint);
                        setmodalContratPrevOpen(true);
                      }}
                    >
                      <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                    </Button>
                    <Button
                      icon
                      {...createStyledButton("card-action", "delete")}
                      onClick={() => {
                        Dialogs.confirm(
                          "Vous êtes sur le point de supprimer le contrat.\nVoulez-vous continuer ?",
                          "Suppression du contrat",
                          () => {
                            context.handleModifyDeleteContratPrevoyance(Infos.id, "Supprimer", "Prevoyance", props.Outil, props.ClientConjoint);
                          }
                        );
                      }}
                    >
                      <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
                    </Button>
                  </>}
                </div>
              </div>
            </div>
          ))}
          {context.state[props.Outil + "ContratFraisPro" + props.ClientConjoint].map((Infos, Index) => (
            <div key={"fraispro-"+Infos.id} className="client-card" style={{ minHeight: 56, padding: '10px 12px' }}>
              <div className="client-card-main">
                <div className="client-card-info">
                  <div className="client-card-avatar" style={{ backgroundColor: '#e0e7ff' }}>
                    <FaBriefcase style={{ color: '#3730a3', fontSize: '16px' }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div className="client-card-row">
                      <h4 className="client-card-title">{props.AccessRemExpress === false ? Infos.LibelleContrat : "Frais professionnels - Risques lourds"}</h4>
                    </div>
                    <div className="client-card-row">
                      <span style={{
                        display: 'inline-block',
                        background: '#e0e7ff', // bleu lavande clair
                        color: '#3730a3', // bleu foncé
                        fontSize: 12,
                        fontWeight: 500,
                        borderRadius: 12,
                        padding: '2px 10px',
                        margin: '2px 0'
                      }}>Frais professionnels</span>
                    </div>
                    <div className="client-card-date">
                      {applyFormat(Number(Infos.FGPMontant), "uint", { thousands: " ", decimal: ",", unit: " € / an" })}
                    </div>
                  </div>
                </div>
                <div className="client-card-actions" style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                  <Button
                    icon
                    {...createStyledButton("card-action", "cardEdit")}
                    onClick={() => {
                      context.handleModifyDeleteContratPrevoyance(Infos.id, "Modifier", "Frais professionnels", props.Outil, props.ClientConjoint);
                      setmodalContratFraisProOpen(true);
                    }}
                  >
                    <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                  </Button>
                  <Button
                    icon
                    {...createStyledButton("card-action", "delete")}
                    onClick={() => {
                      Dialogs.confirm(
                        "Vous êtes sur le point de supprimer le contrat.\nVoulez-vous continuer ?",
                        "Suppression du contrat",
                        () => {
                          context.handleModifyDeleteContratPrevoyance(Infos.id, "Supprimer", "Frais professionnels", props.Outil, props.ClientConjoint);
                        }
                      );
                    }}
                  >
                    <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
                  </Button>
                </div>
              </div>
            </div>
          ))}
          {context.state[props.Outil + "ContratEnregistreSante" + props.ClientConjoint].map((Infos, Index) => (
            <div key={"sante-"+Infos.id} className="client-card" style={{ minHeight: 56, padding: '10px 12px' }}>
              <div className="client-card-main">
                <div className="client-card-info">
                  <div className="client-card-avatar" style={{ backgroundColor: '#fee2e2' }}>
                    <FaHeartbeat style={{ color: '#ef4444', fontSize: '16px' }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div className="client-card-row">
                      <h4 className="client-card-title">{props.AccessRemExpress === false ? Infos.LibelleContratSante : "Santé - Risques lourds"}</h4>
                    </div>
                    <div className="client-card-row">
                      <span style={{
                        display: 'inline-block',
                        background: '#fee2e2',
                        color: '#ef4444',
                        fontSize: 12,
                        fontWeight: 500,
                        borderRadius: 12,
                        padding: '2px 10px',
                        margin: '2px 0'
                      }}>Santé</span>
                    </div>
                    <div className="client-card-date">
                      {applyFormat(Number(Infos.SanteMadelin) + Number(Infos.SanteNonMadelin) + Number(Infos.Cotisation83), "uint", { thousands: " ", decimal: ",", unit: " € / an" })}
                    </div>
                  </div>
                </div>
                <div className="client-card-actions" style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                  {Infos.PayeurPrimeSante === "Entreprise" && <>
                    <Button
                      icon
                      {...createStyledButton("card-action", "cardEdit")}
                      onClick={() => {
                        context.handleModifyDeleteContratSante(Infos.id, "Modifier", props.Outil, props.ClientConjoint);
                        setmodalContratSanteOpen(true);
                      }}
                    >
                      <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                    </Button>
                    <Button
                      icon
                      {...createStyledButton("card-action", "delete")}
                      onClick={() => {
                        Dialogs.confirm(
                          "Vous êtes sur le point de supprimer le contrat.\nVoulez-vous continuer ?",
                          "Suppression du contrat",
                          () => {
                            context.handleModifyDeleteContratSante(Infos.id, "Supprimer", props.Outil, props.ClientConjoint);
                          }
                        );
                      }}
                    >
                      <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
                    </Button>
                  </>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Row>
    </>
  );
}

export default AjoutContratFacultatifPageModal;